<template>
  <a-card :bordered="false">
    <search-page-view
      :col="3"
      ref="pageList"
      :columns="columns"
      :queryParams="queryParams"
      row-key="couponId"
      requestType="get"
      :enableSearch="false"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入优惠券名称" v-model="queryParams.couponName" @search="onSearch"
                        style="max-width: 200px;"/>
        <a-button style="margin-left: 50px" type="primary" @click="toCreate">新建</a-button>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要移除当前优惠券？" @confirm="removeCoupon(rowItem.record)">
          <a>移除</a>
        </a-popconfirm>
      </span>
    </search-page-view>
    <a-modal title="选择优惠券" :footer="null" :width="683" :visible="visible" @cancel="visible = false">
      <search-page-view
        :col="3"
        ref="table"
        :itemNames="['search_orderNo']"
        :columns="columns"
        :queryParams="querySelect"
        row-key="couponId"
        :leftSpace="20"
        :requestPromise="loadPromise1"
      >
        <a-form-item slot="search_orderNo" label="优惠券名称" v-bind="searchItemLayout">
          <a-input v-model="querySelect.couponName" placeholder="请输入"></a-input>
        </a-form-item>
        <span slot="action" slot-scope="rowItem">
        <a @click="selectCoupon(rowItem.record)">选择</a>
      </span>
      </search-page-view>
    </a-modal>
  </a-card>
</template>

<script>
import { USER_SHARE_ID } from '@/store/mutation-types'

export default {
  name: 'BindCoupon',
  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: 'couponId'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName'
        },
        {
          title: '面额',
          dataIndex: 'couponAmout'
        },
        {
          title: '类型',
          dataIndex: 'couponUseTypeStr'
        },
        {
          title: '状态',
          dataIndex: 'couponStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryParams: {
        userShareId: this.$ls.get(USER_SHARE_ID),
        couponName: ''
      },
      querySelect: {
        userShareId: this.$ls.get(USER_SHARE_ID),
        couponName: '',
        couponMerchantId: this.$store.getters.userInfo.merchantId,
        couponPlatformId: this.getPlatformConfig().platformId
      },
      visible: false,
      searchItemLayout: {
        labelCol: {
          xxl: { span: 9 },
          xl: { span: 9 },
          lg: { span: 10 },
          sm: { span: 9 },
          md: { span: 11 },
          xs: { span: 15 }
        },
        wrapperCol: {
          xxl: { span: 14 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 14 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 13 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 13 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 8 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      loadPromise: params => this.getRequest(params),
      loadPromise1: params => this.getSelectList(params)
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BasicSetting', title: '基础设置' },
      { name: 'BindCoupon', title: '优惠券关联' }
    ])
  },
  mounted() {
  },
  methods: {
    removeCoupon(item) {
      let params = {
        couponList: [
          item.couponId
        ],
        userShareId: this.$ls.get(USER_SHARE_ID)
      }
      this.getHttpServices().getServerApiService().post('newUserShare/deleteCouponNewUserShare', params)
        .then(res => {
          this.$message.success('成功移除')
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    selectCoupon(item) {
      this.getLogUtils().logWithTag('-----item-----', item)
      let params = {
        couponList: [
          item.couponId
        ],
        userShareId: this.$ls.get(USER_SHARE_ID)
      }
      this.getHttpServices().getServerApiService().post('newUserShare/saveCouponNewUserShare', params)
        .then(res => {
          this.$message.success('选择成功')
          this.visible = false
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getSelectList(params) {
      this.getLogUtils().logWithTag('-----params1222222222222-----', params)
      if (this.$ls.get(USER_SHARE_ID)) {
        return this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingList', params)
      } else {
        return []
      }
    },
    getRequest(params) {
      let requestParams = {
        limitDto: {
          pageNum: params.pageNum,
          pageSize: params.pageSize
        },
        ...this.queryParams
      }
      this.getLogUtils().logWithTag('-----params9999999999999999999999-----', requestParams)
      if (this.$ls.get(USER_SHARE_ID)) {
        return this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingListByShareId', requestParams)
      } else {
        return []
      }
    },
    onSearch() {
      this.$refs.pageList.refresh(true)
    },
    toCreate() {
      this.visible = true
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style scoped>

</style>